/* eslint-disable react/forbid-prop-types */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import PropTypes from 'prop-types';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import Link from '@mui/material/Link';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InvoicePdfSectionOne from './invoicePdfSectionOne';
import InvoicePdfSectionTwo from './invoicePdfSectionTwo';
import { InvoicePdfSectionThree } from './invoicePdfSectionThree';
import {
  convertPDFURLFromAPI,
  convertPDFFromAPI,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import Preview from './irPreview';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import { getPrintSectionOne, getPrintCover, getPrintSectionTwo, getPrintSectionThree } from '../store/actions';

const styles = {
  MuiTabroot: {
    minWidth: '135px !important',
  },
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));

export default function InvoiceTabs(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const {
    invoiceDetailsByInvoiceNum,
    fullScreenView,
    setFullScreenView,
    handleErrorMessages,
  } = props;

  const invoiceQuarter = useSelector(
    (state) => state?.sharedState.DisplayInvoiceReducer.invoiceQuarter
  );
  const pdfDraftPreview = useSelector(
    (state) => state?.sharedState.InvoiceReportReducer?.pdfCoverPreview
  );
  const invoiceLetterTableData = useSelector(
    (state) => state?.sharedState?.InvoiceReportReducer?.invoiceLetterTableData
  );
  const searchInvoiceRequest = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.searchInvoiceReportRequest
  );
  const invoiceNumber = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.invoiceDetailsByInvoiceNum?.data
        ?.invoiceNum || null
  );
  const invoiceDetailData = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.invoiceDetailsByInvoiceNum?.data
  );
  const saveCoverLetter = useSelector(
    (state) => state?.sharedState?.InvoiceReportReducer?.saveCoverLetter
  );
  const invGridFlag = useSelector(
    (state) => state?.sharedState?.InvoiceReportReducer?.invGridFlag
  );
  const pdfSectionOnePreview = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.pdfSectionOnePreview
  );
  const pdfSectionTwoPreview = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.pdfSectionTwoPreview
  );
  const pdfSectionThreePreview = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.pdfSectionThreePreview
  );
  const UserDefaultValues = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
      (state) => state?.sharedState?.SharedReducer?.logInUser
    );
  localStorage.setItem('UserDefaultValues', JSON.stringify(UserDefaultValues));

  const errorMess = useSelector(
      (state) => state.sharedState?.InvoiceReportReducer?.errorMessages
  );

  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfURL] = React.useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (
      (newValue === 3 || newValue === 2 || newValue === 0 || newValue === 1) &&
      pdfDraftPreview instanceof ArrayBuffer &&
      pdfDraftPreview.byteLength > 0
    ) {
      handleErrorMessages([]);
    }
  };

  const myArray =
    invoiceLetterTableData && invoiceLetterTableData.letterHeaderVOs;
  const coverLetters = myArray?.filter((e) => e.templateTypeCd === "COVER");
  const letterData = _.maxBy(coverLetters, (e) => e.letterId);

  // draft pdf url
  useEffect(() => {
    if (value === 0 && (!pdfDraftPreview || pdfDraftPreview === '')) {
      setLoading(false);
      const remainingErrors = (errorMess || []).filter(
        (x) =>
          x &&
          !String(x).includes(CONSTANTS.INVOICE_NOT_FOUND) &&
          !String(x).toLowerCase().includes('no record')
      );
      handleErrorMessages(remainingErrors);
    } else if (pdfDraftPreview && pdfDraftPreview !== '') {
      const purl = convertPDFURLFromAPI(pdfDraftPreview);
      setPdfURL(purl);
      setLoading(false);
    }
  }, [pdfDraftPreview, props.duplicateInvoice, value]);

  useEffect(() => {
    if (errorMess.length > 0) {
      setLoading(false);
    } 
  }, [errorMess]);

  const rebateProgramCd =
    invoiceDetailsByInvoiceNum?.rebateProgramCd ||
    invoiceDetailData?.rebateProgramCd ||
    searchInvoiceRequest?.rebateProgramCode;
  const planTypeCd =
    invoiceDetailsByInvoiceNum?.planTypeCd ||
    invoiceDetailData?.planTypeCd ||
    searchInvoiceRequest?.planType;

  useEffect(() => {
    setValue(0);
    setPdfURL(null);
  }, [invoiceNumber]);

  useEffect(() => {
    if (invoiceNumber && rebateProgramCd) {
      setLoading(true);
      const payload = {
        invoiceNum: [invoiceNumber],
        rebateProgramCd,
        userId: UserDefaultValues?.userId,
        duplicate: props.duplicateInvoice,
        planTypeCd,
      };
      dispatch(getPrintCover(payload));
      dispatch(getPrintSectionOne(payload));
      dispatch(getPrintSectionTwo(payload));
      dispatch(getPrintSectionThree(payload));
    }
  }, [
    props.duplicateInvoice,
    invoiceNumber,
    rebateProgramCd,
    planTypeCd,
    invoiceDetailData,
    UserDefaultValues?.userId,
  ]);

  const onClickPrintSec = async () => {
    setLoading(true);
    const payload = {
        invoiceNum: [invoiceNumber],
        rebateProgramCd,
        userId: logInUser,
        duplicate: props.duplicateInvoice,
    };
    try {
      const response = await axios.post(
        `${serviceEndPoint.INVOICE_GET_REPORT_COVER}`,
        payload,
        {
          responseType: 'arraybuffer',
          headers: {
            Accept: 'application/octet-stream',
          },
        }
      );
      setLoading(false);
      convertPDFFromAPI(response.data);
    } catch (error) {
      setLoading(false);
      handleErrorMessages([CONSTANTS.NO_DATA_PRINT]);
    }
  };

  const hasPreview = (p) => {
    if (!p) return false;
    if (Array.isArray(p)) return p.length > 0;
    if (p instanceof ArrayBuffer) return p.byteLength > 0;
    if (p?.data instanceof ArrayBuffer) return p.data.byteLength > 0;
    if (typeof p === 'object') return Object.keys(p).length > 0; // non-empty object
    // fallback for strings/numbers
    return Boolean(p);
  };

  return (
    <>
      {!fullScreenView && (
        <>
          {loading && <Spinner load={loading} />}
          <div className='tabs-wrapper d-flex justify-content-between'>
            <div className={classes.root}>
              <AppBar position='static'>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label='lab API tabs example'
                  variant='standard'
                >
                  {saveCoverLetter?.invFlagRes !== 'L' && (
                    <Tab
                      label='Cover Letter'
                      {...a11yProps(0)}
                      className='MuiTabroot'
                      style={{ width: '150px' }}
                      tabIndex={0}
                    />
                  )}
                  <Tab
                    label='Sec I: Current Quarter '
                    {...a11yProps(1)}
                    style={{
                      width: '180px',
                    }}
                    tabIndex={0}
                  />
                  {hasPreview(pdfSectionTwoPreview) && 
                  <Tab
                    label='Sec II: Unit Changes'
                    {...a11yProps(2)}
                    style={{ width: '180px' }}
                  />
                  }
                  {hasPreview(pdfSectionThreePreview) && invGridFlag?.invFlagRes !== 'NONE' && (
                    <Tab
                      label="Sec III: Prior Quarters"
                      {...(hasPreview(pdfSectionTwoPreview)
                        ? (saveCoverLetter?.invFlagRes === 'F' || saveCoverLetter?.invFlagRes === null
                          ? a11yProps(3)
                          : (saveCoverLetter?.invFlagRes === 'L' ? a11yProps(2) : a11yProps(3)))
                        : (saveCoverLetter?.invFlagRes === 'F' || saveCoverLetter?.invFlagRes === null
                          ? a11yProps(2)
                          : (saveCoverLetter?.invFlagRes === 'L'
                            ? a11yProps(1)
                            : a11yProps(2))
                        )
                      )}
                      style={{ maxWidth: '200px' }}
                      tabIndex={0}
                    />
                  )}
                  {saveCoverLetter?.invFlagRes == 'L' &&
                    invGridFlag?.invFlagRes == 'NONE' && (
                      <Tab
                        label='Cover Letter'
                        {...a11yProps(3)}
                        className='MuiTabroot'
                        style={{ width: '150px' }}
                      />
                    )}
                  {saveCoverLetter?.invFlagRes == 'L' &&
                    invGridFlag?.invFlagRes != 'NONE' && (
                      <Tab
                        label='Cover Letter'
                        {...a11yProps(4)}
                        className='MuiTabroot'
                        style={{ width: '150px' }}
                        tabIndex={0}
                      />
                    )}
                </Tabs>
              </AppBar>
            </div>
            <div className='d-flex align-items-center th-icon-group' />
            <div className='clearfix' />
          </div>
          <TabPanel
              value={value}
              index={
                saveCoverLetter?.invFlagRes === 'F' || saveCoverLetter?.invFlagRes === null
                  ? 0
                  : (saveCoverLetter?.invFlagRes === 'L'
                    ? (hasPreview(pdfSectionTwoPreview) && hasPreview(pdfSectionThreePreview)
                      ? 3
                      : (hasPreview(pdfSectionTwoPreview) && !hasPreview(pdfSectionThreePreview)
                        ? 2
                        : (!hasPreview(pdfSectionTwoPreview) && hasPreview(pdfSectionThreePreview)
                          ? 2
                          : 1)))
                    : 0)
              }
            >
            <div className='tab-body'>
              <div className='tab-container' bodyground='white'>
                {!fullScreenView && (
                  <>
                    {' '}
                    <div className='row'>
                      <div className='col-4 pl-0 pr-0'>
                        <div className='text-left'>Display Letter</div>
                      </div>
                      <div className='col-8'>
                        <div className='text-right font-weight-bold'>
                          <Link
                            component='button'
                            variant='body2'
                            onClick={() => {
                              onClickPrintSec();
                            }}
                          >
                            Print this Section
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className='mui-custom-form no-margin custom-check'>
                      <div className='mt-2'>
                        <fieldset
                          data-testid='radio-box-component'
                          className='custom-fieldset'
                        >
                          <div className='row'>
                            <div className='col-12 col-sm-3 mb-2'>
                              <SelectBoxWithoutBoxComponent
                                data-testid='letter-id-select-box'
                                className='mt-2'
                                labelName='Letter ID'
                                disabled
                                select={false}
                                defaultValue={letterData?.letterId}
                              />
                            </div>
                            <div className='col-12 col-sm-3 mb-2'>
                              {letterData?.templateName?.length > 26 ? (
                                <OverlayTrigger
                                  placement='bottom'
                                  overlay={
                                    <Tooltip id='com-tooltip'>
                                      {letterData?.templateName}
                                    </Tooltip>
                                  }
                                >
                                  <SelectBoxWithoutBoxComponent
                                    data-testid='name-input-box'
                                    className='mt-2'
                                    labelName='Name'
                                    required={false}
                                    disabled
                                    select={false}
                                    defaultValue={`${letterData?.templateName.substring(
                                      0,
                                      26
                                    )} ...`}
                                  />
                                </OverlayTrigger>
                              ) : (
                                <SelectBoxWithoutBoxComponent
                                  data-testid='name-input-box'
                                  className='mt-2'
                                  labelName='Name'
                                  required={false}
                                  disabled
                                  select={false}
                                  defaultValue={letterData?.templateName}
                                />
                              )}
                            </div>
                            <div className='col-12 col-sm-3 mb-2'>
                              <SelectBoxWithoutBoxComponent
                                data-testid='mfg-id-input-box'
                                className='mt-2'
                                labelName='MFG ID'
                                required={false}
                                disabled
                                select={false}
                                defaultValue={invoiceDetailsByInvoiceNum?.mfgId}
                              />
                            </div>
                            <div className='col-12 col-sm-3 mb-2'>
                              <SelectBoxWithoutBoxComponent
                                data-testid='Sent-input-box'
                                labelName='Sent'
                                required={false}
                                disabled
                                select={false}
                                defaultValue={letterData?.sentDt}
                              />
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <Preview pdfUrlLink={pdfUrl} />
            </div>
          </TabPanel>
        </>
      )}
      <TabPanel
        value={value}
        index={saveCoverLetter?.invFlagRes !== 'L' ? 1 : 0}
      >
        <InvoicePdfSectionOne
          setLoading={setLoading}
          setFullScreenView={setFullScreenView}
          fullScreenView={fullScreenView}
          duplicateInvoice={props.duplicateInvoice}
          handleErrorMessages={handleErrorMessages}
        />
       </TabPanel>
      {hasPreview(pdfSectionTwoPreview) && 
        <TabPanel
          value={value}
          index={saveCoverLetter?.invFlagRes !== 'L' ? 2 : 1}
        >
          <InvoicePdfSectionTwo
            setLoading={setLoading}
            setFullScreenView={setFullScreenView}
            fullScreenView={fullScreenView}
            duplicateInvoice={props.duplicateInvoice}
            handleErrorMessages={handleErrorMessages}
          />
        </TabPanel>
      }
      {(invGridFlag?.invFlagRes !== 'NONE') && (
        <TabPanel
          value={value}
          index = {
            hasPreview(pdfSectionTwoPreview)
              ? (saveCoverLetter?.invFlagRes === 'F' || saveCoverLetter?.invFlagRes === null
                  ? 3
                  : (saveCoverLetter?.invFlagRes === 'L' ? 2 : 3))
              : (saveCoverLetter?.invFlagRes === 'F' || saveCoverLetter?.invFlagRes === null
                  ? 2
                  : (saveCoverLetter?.invFlagRes === 'L'
                    ? 1
                    : 2))
          }
        >
          <InvoicePdfSectionThree
            setLoading={setLoading}
            setFullScreenView={setFullScreenView}
            fullScreenView={fullScreenView}
            duplicateInvoice={props.duplicateInvoice}
            handleErrorMessages={handleErrorMessages}
          />
        </TabPanel>
      )}
    </>
  );
}
